module.exports = __webpack_public_path__ + "img/broccoli.be5030ca.webp";